import React from "react";
import { connect } from "react-redux";
import { Button, message, Popover } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";

import ajaxUtil from "../../util/ajax";
import AjaxAction from "../../actions/AjaxAction.js";

import "./GalleryPreview.scss";
import { copyToClipboard } from "../../util/index.js";

const { DOMAIN_CURRENT, ajaxv2 } = ajaxUtil;

const makeQrcodeByURL = async (url) => {
  return await window.QRCode.toDataURL(url, {
    margin: 2,
    scale: 16,
  });
};

export const QrcodeAsImage = ({ url }) => {
  const [qrcode, setQrcode] = React.useState(null);
  React.useEffect(() => {
    makeQrcodeByURL(url).then((res) => {
      setQrcode(res);
    });
  }, [url]);

  return <img style={{ width: 180 }} alt="" src={qrcode} />;
};

export const fetchGalleryByOrderId = (orderid) => {
  return ajaxv2({
    url: DOMAIN_CURRENT + "/api/v2/gallery/show?",
    data: {
      orderid,
      parent: 0,
    },
  });
};

export const fetchPreviewInfo = (orderid, dispatch) => {
  if (orderid) {
    return new Promise((resolve) => {
      fetchGalleryByOrderId(orderid).then((res) => {
        if (res && res.id) {
          let gallery = res;
          let origin = null;
          if (dispatch && gallery && gallery.orderid) {
            dispatch(AjaxAction.galleryOriginInfo(gallery.orderid)).then(
              (res) => {
                origin = res.data;
                resolve({
                  gallery,
                  origin,
                });
              }
            );
          } else {
            resolve({
              gallery,
            });
          }
        } else {
          resolve({});
        }
      });
    });
  } else {
    return new Promise((resolve) => resolve({}));
  }
};

class GalleryPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      origin: null,
      gallery: null,
      qrcodeH5: "",
    };
  }

  componentDidMount() {
    if (this.props.orderid) {
      fetchPreviewInfo(this.props.orderid, this.props.dispatch).then((res) => {
        let { origin, gallery } = res;

        this.setState(
          {
            origin,
            gallery,
          },
          () => {
            this.makeQrcode();
          }
        );
      });
    } else {
      this.makeQrcode();
    }
  }

  async makeQrcode() {
    let { origin, gallery } = this.getData();
    this.setState({
      qrcodeNewOrigin: await makeQrcodeByURL(
        `http://consumer.jimage.cn/mobile/gti/${gallery.url_labeling}/raw`
      ),
      qrcodeH5: await makeQrcodeByURL(
        `http://live.jimage.cn/gti/${gallery.url_labeling}`
      ),
      qrcodeNowatermark: await makeQrcodeByURL(
        `http://live.jimage.cn/gti/${gallery.url_labeling}/original/1`
      ),
      qrcodeQuality: await makeQrcodeByURL(
        `http://consumer.jimage.cn/mobile/gti/${gallery.url_labeling}`
      ),
      qrcodeOrigin:
        origin && origin.sortLink
          ? await makeQrcodeByURL(origin.sortLink)
          : undefined,
    });
  }

  getData() {
    if (this.props.orderid) {
      return this.state;
    } else {
      return this.props;
    }
  }

  render() {
    let { origin, gallery } = this.getData();
    const {
      qrcodeH5,
      qrcodeNowatermark,
      qrcodeOrigin,
      qrcodeQuality,
      qrcodeNewOrigin,
    } = this.state;

    return gallery && gallery.id ? (
      <Popover
        placement={this.props.placement || "bottomRight"}
        overlayStyle={{ zIndex: 1031 }}
        content={
          <div className="gallery-preview">
            <div>
              <span>H5版</span>
              <img style={{ width: 180 }} alt="" src={qrcodeH5} />
              <div>
                <CopyToClipboard
                  text={`http://live.jimage.cn/gti/${gallery.url_labeling}`}
                  onCopy={() => message.success("复制成功")}
                >
                  <a>复制链接</a>
                </CopyToClipboard>
                <a
                  style={{ marginLeft: 5 }}
                  onClick={() =>
                    window.open(
                      `http://live.jimage.cn/gti/${gallery.url_labeling}`,
                      `preview_${gallery.id}`
                    )
                  }
                >
                  点击跳转
                </a>
              </div>
              <div>
                <span style={{ color: "#d90000" }}>装修后生效</span>
              </div>
            </div>
            {gallery && !this.props.simpleMode ? (
              <div>
                <span>无水印版</span>
                <img style={{ width: 180 }} alt="" src={qrcodeNowatermark} />
                <div>
                  <CopyToClipboard
                    text={`【无水印相册】
活动名称：${gallery.name}
链接：http://live.jimage.cn/gti/${gallery.url_labeling}/original/1
密码：${gallery.watermark_password}
---------------------------------------
此相册可查看无水印照片，仅建议媒体宣发、重要嘉宾供图等内部环节使用，转发复制此链接文本，请勿公开`}
                    onCopy={(text) => {
                      message.success("复制成功");
                      // 额外复制一下，有些操作系统和环境有问题
                      copyToClipboard(text);
                    }}
                  >
                    <a>复制链接</a>
                  </CopyToClipboard>
                  <a
                    style={{ marginLeft: 5 }}
                    onClick={() =>
                      window.open(
                        `http://live.jimage.cn/gti/${gallery.url_labeling}/original/1`
                      )
                    }
                  >
                    点击跳转
                  </a>
                </div>
                {!gallery.watermark_password ? (
                  <div>
                    <span style={{ color: `#d90000` }}>未设置无水印密码</span>
                  </div>
                ) : null}
              </div>
            ) : null}
            {origin && origin.sortLink && !this.props.simpleMode ? (
              <div>
                <span>原片</span>
                <img style={{ width: 180 }} alt="" src={qrcodeOrigin} />
                <div>
                  <CopyToClipboard
                    text={`活动名称：${origin.name}
原片相册链接：${origin.sortLink}
密码：${origin.password}
---------------------------------------
您可将照片“标记必选”或“标记删除”，修图师会在后台及时调整；
请勿泄露原片相册密码，以免造成风险。`}
                    onCopy={(text) => {
                      message.success("复制成功");
                      // 额外复制一下，有些操作系统和环境有问题
                      copyToClipboard(text);
                    }}
                  >
                    <a>复制链接</a>
                  </CopyToClipboard>
                  <a
                    style={{ marginLeft: 5 }}
                    onClick={() => window.open(`${origin.sortLink}`)}
                  >
                    点击跳转
                  </a>
                </div>
              </div>
            ) : null}
            {!this.props.simpleMode ? <div>
              <span>新版原片</span>
              <img style={{ width: 180 }} alt="" src={qrcodeNewOrigin} />
              <div>
                <CopyToClipboard
                  text={`活动名称：${gallery.name}
原片相册链接：http://consumer.jimage.cn/mobile/gti/${gallery.url_labeling}/raw
请输入手机号验证码登录
---------------------------------------
您可将照片“标记待补选”或“标记删除”，修图师会在后台及时调整；
请勿泄露原片相册，以免造成风险。`}
                  onCopy={(text) => {
                    message.success("复制成功");
                    // 额外复制一下，有些操作系统和环境有问题
                    copyToClipboard(text);
                  }}
                >
                  <a>复制链接</a>
                </CopyToClipboard>
                <a
                  style={{ marginLeft: 5 }}
                  onClick={() =>
                    window.open(
                      `http://consumer.jimage.cn/mobile/gti/${gallery.url_labeling}/raw`
                    )
                  }
                >
                  点击跳转
                </a>
              </div>
            </div> : null}
            {!window.actionFor("gallery-edit", "boolean") && !this.props.simpleMode ? (
              <div>
                <span>品控</span>
                <img style={{ width: 180 }} alt="" src={qrcodeQuality} />
                <div>
                  <CopyToClipboard
                    text={`相册名称：${gallery.name}
即享品控相册链接：http://consumer.jimage.cn/mobile/gti/${gallery.url_labeling}
---------------------------------------
您可操作照片“公开”或“隐藏”，请勿泄露密码，以免造成风险。`}
                    onCopy={(text) => {
                      message.success("复制成功");
                      // 额外复制一下，有些操作系统和环境有问题
                      copyToClipboard(text);
                    }}
                  >
                    <a>复制链接</a>
                  </CopyToClipboard>
                  <a
                    style={{ marginLeft: 5 }}
                    onClick={() =>
                      window.open(
                        `http://consumer.jimage.cn/mobile/gti/${gallery.url_labeling}`
                      )
                    }
                  >
                    点击跳转
                  </a>
                </div>
              </div>
            ) : null}
            {!this.props.simpleMode ? <div>
              <span>小程序版</span>
              <img
                style={{ width: 180 }}
                alt=""
                src={
                  "https://live.jimage.cn/api/common/miniqrcode?url=" +
                  encodeURIComponent(
                    `https://live.jimage.cn/gti/${gallery.url_labeling}`
                  ) +
                  "&scale=16"
                }
              />
              <div>
                <span style={{ color: "#d90000" }}>装修后生效</span>
              </div>
            </div> : null}
          </div>
        }
        title={
          <span>
            使用微信扫描二维码
            {!window.actionFor("gallery-edit", "boolean") &&
              origin &&
              origin.sortLink ? (
              <a
                target={`allinone_${gallery.id}`}
                href={`/page/quality/allinone?h5=${encodeURIComponent(
                  `http://live.jimage.cn/gti/${gallery.url_labeling}`
                )}&origin=${encodeURIComponent(
                  `${origin.sortLink}`
                )}&quality=${encodeURIComponent(
                  `http://consumer.jimage.cn/mobile/gti/${gallery.url_labeling}`
                )}`}
              >
                （品控专用三合一链接）
              </a>
            ) : null}
          </span>
        }
      >
        <Button size={this.props.size || "default"}>预览</Button>
      </Popover>
    ) : null;
  }
}

export default connect((state) => {
  return state;
})(GalleryPreview);


// WEBPACK FOOTER //
// ./src/components/Common/GalleryPreview.js